module.exports = __webpack_public_path__ + "assets/img/3f93a50a94a46aa95bde91b4e2008f00.svg";